import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IClientPostbacks } from '../../_common/_interfaces/IClientPostbacks';

export const PostbackActions = createActionGroup({
  source: 'Postback',
  events: {
    'Load Client Postbacks': emptyProps(),
    'Load Client Postbacks Success': props<{ data: IClientPostbacks }>(),
    'Load Client Postbacks Failure': props<{ error: any }>(),

    'Save Client Postbacks': props<{ payload: IClientPostbacks }>(),
    'Save Client Postbacks Success': props<{ data: IClientPostbacks }>(),
    'Save Client Postbacks Failure': props<{ error: any }>(),
  },
});
